import { IWorkspaceData, IWorkspace, IApplication,IConceptNote, ISubMenu, IApplicationSubmit, ITechnicalApplication, IApplicationBudget, IApplicantDueDeligence, INotification } from './workspace.types'
import { ValidationMessage, IValidationMessage } from '../common'
import { AppConstants as _app } from '@/shared/app.constants'

export class Workspace implements IWorkspace {
    templates: any
    selectedApplication: number
    selectedConceptNote: number
    selectedCall: number
    selectedItem: string
    language: string
    topMenu: string
    subMenu: SubMenu
    notification: INotification
    application: IApplication
    conceptNote: IConceptNote
    data: any
    technicalApplication:  ITechnicalApplication
    applicationBudget: IApplicationBudget
    applicantDueDeligence: IApplicantDueDeligence
    applicationSubmit: IApplicationSubmit
    indicators: any
    negotiationLog: any
    overlay: boolean
    showValidationDilog: boolean
    validationMessages: Array<IValidationMessage>
    checklist: any
    logSchema: any

    constructor(workspace: IWorkspace) {
        this.selectedApplication = workspace.selectedApplication
        this.selectedConceptNote = workspace.selectedConceptNote
        this.selectedCall = workspace.selectedCall
        this.templates = workspace.templates || {}
        this.data = workspace.templates || {}
        this.selectedItem = workspace.selectedItem || _app.workspace.default_menu
        this.language = workspace.language || _app.workspace.default_lang
        this.application = new Application(workspace.application || ({} as IApplication))
        this.conceptNote = new ConceptNote(workspace.conceptNote || ({} as IConceptNote))
        this.technicalApplication = new TechnicalApplication(workspace.technicalApplication || ({} as ITechnicalApplication))
        this.applicationBudget = new ApplicationBudget(workspace.applicationBudget || {} as IApplicationBudget)
        this.applicantDueDeligence = new ApplicantDueDeligence(workspace.applicantDueDeligence || {} as IApplicantDueDeligence)
        this.applicationSubmit = new ApplicationSubmit(workspace.applicationSubmit || {} as IApplicationSubmit)
        this.notification = new Notification(workspace.notification || {} as INotification)
        this.topMenu = workspace.topMenu || ''
        this.subMenu = new SubMenu(workspace.subMenu || {} as ISubMenu)
        this.indicators = workspace.indicators || []
        this.negotiationLog = workspace.negotiationLog || []
        this.overlay = workspace.overlay || false
        this.showValidationDilog = workspace.showValidationDilog || false
        this.validationMessages = (workspace.validationMessages || []).map((x) => new ValidationMessage(x))
        this.checklist = workspace.checklist
        this.logSchema = workspace.logSchema
    }
}

export class SubMenu implements ISubMenu {
    technicalApplication: string
    applicantDueDeligence: string
    logFramework: string

    constructor(subMenu: ISubMenu) {
        this.technicalApplication = subMenu.technicalApplication || '';
        this.applicantDueDeligence = subMenu.applicantDueDeligence || '';
        this.logFramework = subMenu.logFramework || '';
    }
}

/** class for application */
export class Application implements IApplication {
    ApplicationId: number
    ConceptNoteId: number
    BudgetAmount: number
    GrantTypeId: number
    Title: string
    BudgetType: string
    Country: string
    RequestedAmount: number
    TotalProjectBudget: number
    ProjectDuration: string
    StartDate: Date
    EndDate: Date
    LeadPartner: string
    InitiativeCallId: number
    WorkflowStatusId: number
    WorkflowStatusCode: string
    CreatedById: string
    CreatedDate: Date
    WorkflowInfo: any
    ReportingFrequency: number
    Comments: string
    BudgetCurrency: string
    uniqueID: string
    Latitude: string
    Longitude: string
    PrimaryProgramOfficerId: number
    Countries:any
    Regions: any
    Duration:number
    IsMigrated: boolean
    Code: string
    ConceptNoteCode: string
    AllowCustomIndicator: number
    IsFixedIndirectCost: any
    Subject: string
    notify: boolean
    IndirectCost: number
    MatchFunding: number
    

    constructor(application: IApplication) {
        this.ApplicationId = application.ApplicationId
        this.ConceptNoteId = application.ConceptNoteId
        this.BudgetAmount = application.BudgetAmount // from call
        this.GrantTypeId = application.GrantTypeId // from call
        this.Title = application.Title
        this.InitiativeCallId = application.InitiativeCallId
        this.Country = application.Country
        this.WorkflowStatusId = application.WorkflowStatusId
        this.WorkflowStatusCode = application.WorkflowStatusCode
        this.RequestedAmount = application.RequestedAmount
        this.CreatedById = application.CreatedById
        this.CreatedDate = application.CreatedDate
        this.TotalProjectBudget = application.TotalProjectBudget
        this.ProjectDuration = application.ProjectDuration
        this.StartDate = application.StartDate
        this.EndDate = application.EndDate
        this.LeadPartner = application.LeadPartner
        this.WorkflowInfo = application.WorkflowInfo
        this.ReportingFrequency = application.ReportingFrequency
        this.Comments = application.Comments
        this.BudgetCurrency = application.BudgetCurrency
        this.uniqueID = application.uniqueID
        this.BudgetType = application.BudgetType // from call
        this.Latitude = application.Latitude
        this.Longitude = application.Longitude
        this.PrimaryProgramOfficerId = application.PrimaryProgramOfficerId
        this.Countries=application.Countries
        this.Regions = application.Regions
        this.Duration=application.Duration
        this.IsMigrated = application.IsMigrated
        this.Code=application.Code
        this.ConceptNoteCode=application.ConceptNoteCode
        this.Duration=application.Duration
        this.AllowCustomIndicator = application.AllowCustomIndicator
        this.IsFixedIndirectCost = application.IsFixedIndirectCost
        this.Subject = application.Subject
        this.notify = application.notify
        this.IndirectCost = application.IndirectCost
        this.MatchFunding = application.MatchFunding
    }
}

/** class for technical application */
export class TechnicalApplication implements ITechnicalApplication {
    templates: any
    selectedKey: string
    data: any
    constructor(technicalApplication: ITechnicalApplication) {
        this.templates = technicalApplication.templates || {}
        this.data = technicalApplication.data || {}
        this.selectedKey = technicalApplication.selectedKey || ''
    }
}

/** class for application budget */
export class ApplicationBudget implements IApplicationBudget {
    templates: any
    data: any
    constructor(applicationBudget: IApplicationBudget) {
        this.templates = applicationBudget.templates || {}
        this.data = applicationBudget.data || {}
    }
}

/** class for application submit */
export class ApplicationSubmit implements IApplicationSubmit {
    templates: any
    data: any
    checklist: any
    constructor(applicationSubmit: IApplicationSubmit) {
        this.templates = applicationSubmit.templates || {}
        this.data = applicationSubmit.data || {}
        this.checklist = applicationSubmit.checklist
    }
}

/** class for application due deligence */
export class ApplicantDueDeligence implements IApplicantDueDeligence {
    templates: any
    selectedKey: string
    data: any
    constructor(applicantDueDeligence: IApplicantDueDeligence) {
        this.templates = applicantDueDeligence.templates || {}
        this.data = applicantDueDeligence.data || {}
        this.selectedKey = applicantDueDeligence.selectedKey || _app.workspace.default_due_diligence_key
    }
}

/** class for Notification */
export class Notification implements INotification {
    snack: boolean
    color: string
    text: string
    timeOut: number
    isHtml: boolean
    constructor(notification: INotification) {
        this.snack = notification.snack || false
        this.color = notification.color || 'success'
        this.text = notification.text || ''
        this.timeOut = notification.timeOut || 6000
        this.isHtml = notification.isHtml || false;
    }
}

/** class for Concpet Note */
export class ConceptNote implements IConceptNote {
    ConceptNoteId: number
    GrantTypeId: number
    Code: string
    Title: string
    Country: string
    StartDate: Date
    EndDate: Date
    ProjectDuration: string
    RequestedAmount: number
    TotalProjectBudget: number
    Latitude: string
    Longitude: string
    LeadPartner: string
    PrimaryProgramOfficerId: number

    BudgetType: string
    BudgetAmount: number
    InitiativeCallId: number
    WorkflowStatusId: number
    WorkflowStatusCode: string
    CreatedById: string
    CreatedDate: Date
    WorkflowInfo: any
    ReportingFrequency: number
    Comments: string
    BudgetCurrency: string
    uniqueID: string
    Countries:any
    Regions: any
    Duration:number
    AllowCustomIndicator: number
    IndirectCost: number
    IsFixedIndirectCost: any
    Subject: string
    notify: boolean

    constructor(conceptNote: IConceptNote) {
        this.ConceptNoteId = conceptNote.ConceptNoteId
        this.GrantTypeId = conceptNote.GrantTypeId
        this.Code = conceptNote.Code
        this.Title = conceptNote.Title
        this.Country = conceptNote.Country
        this.StartDate = conceptNote.StartDate
        this.EndDate = conceptNote.EndDate
        this.ProjectDuration = conceptNote.ProjectDuration
        this.RequestedAmount = conceptNote.RequestedAmount
        this.TotalProjectBudget = conceptNote.TotalProjectBudget
        this.Latitude = conceptNote.Latitude
        this.Longitude = conceptNote.Longitude
        this.LeadPartner = conceptNote.LeadPartner
        this.PrimaryProgramOfficerId = conceptNote.PrimaryProgramOfficerId

        this.BudgetType = conceptNote.BudgetType
        this.BudgetAmount = conceptNote.BudgetAmount
        this.InitiativeCallId = conceptNote.InitiativeCallId
        this.WorkflowStatusId = conceptNote.WorkflowStatusId
        this.WorkflowStatusCode = conceptNote.WorkflowStatusCode
        this.CreatedById = conceptNote.CreatedById
        this.CreatedDate = conceptNote.CreatedDate
        this.WorkflowInfo = conceptNote.WorkflowInfo
        this.ReportingFrequency = conceptNote.ReportingFrequency
        this.Comments = conceptNote.Comments
        this.BudgetCurrency = conceptNote.BudgetCurrency
        this.uniqueID = conceptNote.uniqueID
        this.Countries = conceptNote.Countries
        this.Regions = conceptNote.Regions
        this.Duration = conceptNote.Duration
        this.AllowCustomIndicator = conceptNote.AllowCustomIndicator
        this.IndirectCost = conceptNote.IndirectCost
        this.IsFixedIndirectCost = conceptNote.IsFixedIndirectCost
        this.Subject = conceptNote.Subject
        this.notify = conceptNote.notify
    }
}
